import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-modal-location',
  templateUrl: './modal-location.component.html',
  styleUrls: ['./modal-location.component.scss']
})
export class ModalLocationComponent implements OnInit {
  @Input() isCreating: boolean = true;
  loading = false;
  @Output() close = new EventEmitter<boolean>();
  nameLocation = "";
  addressLocation = "";

  constructor(
    private rrhhService: HumanResourcesService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {

  }

  addLocation() {
    var temp = {
      address: this.addressLocation,
      company: null,
      name: this.nameLocation
    }
    this.loading = true;
    this.rrhhService.addLocation(temp).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Ubicación creada con exito!");
        this.loading = false;
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error(error.error.message);
      }
    })
  }
}
